module.exports = __webpack_public_path__ + "img/category-4.3539418b.svg";